import { format } from 'date-fns';
export const getDifferenceInMinutesFromNow = (endDate) => {
    const now = new Date().getTime();
    endDate = new Date(endDate * 1000).getTime();
    const difference = endDate - now;
    const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((difference % (1000 * 60)) / 1000);
    const time = `${minutes}:${('0' + seconds).slice(-2)}`;
    return { time, difference };
};
export const formatDate = (unixTimestamp) => {
    const date = new Date(unixTimestamp * 1000);
    const formattedDate = format(date, "MMM d, yyyy 'at' h:mma").replace(/AM|PM/, (match) => match.toLowerCase());
    return formattedDate;
};
export const formatTimestamp = (unixTimestamp) => {
    const date = new Date(unixTimestamp * 1000);
    return {
        time: format(date, 'h:mma').toLowerCase(),
        monthDate: format(date, 'MMMM d'),
    };
};
